/* ══════════════════════════════════════════════════════
   CART DRAWER JS — Assets/cart-drawer.js — REPLACE FULLY
   ══════════════════════════════════════════════════════ */

(function() {
  'use strict';

  // ── Your discount tiers (amounts in paise) ──
  var TIERS = [
    { min: 1000000, pct: 3, code: 'Rangoli3%', label: '3% off', tag: '₹10K' },
    { min: 2000000, pct: 5, code: 'Rangoli5%', label: '5% off', tag: '₹20,000' }
  ];

  // ── Feature toggles (managed by Cart Drawer Manager app) ──
  var CONFIG = {
    showItemSaving: true,
    showCompare: true,
    showTotalSaving: true,
    showConfetti: false,
    showUpsell: true,
    upsellMax: 6,
    showShipTag: true,
    shipEmoji: '🚚',
    shipText: 'Free Delivery',
    shipSubtext: 'on all orders',
    upsellTitle: 'You might also like'
  };

  var drawer, overlay, closeBtn;
  var prevTier = -1;

  // Compare-at (MRP) prices keyed by variant id, in paise.
  // Seeded from Liquid (window.CD_COMPARE) for current cart items, and
  // topped up from product data for any newly added items.
  var compareCache = window.CD_COMPARE || {};

  // Fetch compare-at prices for any cart items we don't already know.
  function ensureCompareData(items) {
    var handlesToFetch = {};
    for (var i = 0; i < items.length; i++) {
      var vid = items[i].variant_id || items[i].id;
      if (!(vid in compareCache) && items[i].handle) {
        handlesToFetch[items[i].handle] = true;
      }
    }
    var handles = Object.keys(handlesToFetch);
    if (handles.length === 0) return Promise.resolve();
    return Promise.all(handles.map(function(h) {
      return fetch('/products/' + h + '.js')
        .then(function(r) { return r.json(); })
        .then(function(prod) {
          (prod.variants || []).forEach(function(v) {
            compareCache[v.id] = (v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : 0;
          });
        })
        .catch(function() {});
    }));
  }

  function init() {
    drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    applyStaticConfig();
    overlay = drawer.querySelector('.cd__overlay');
    closeBtn = document.getElementById('cd-close');

    var total = parseInt(drawer.dataset.cartTotal || '0', 10);
    prevTier = getTier(total);

    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') close(); });

    // Robust "click anywhere outside the drawer to close".
    // Doesn't rely on the overlay catching the click (z-index can break that).
    document.addEventListener('click', function(e) {
      // Only act when the drawer is open
      if (drawer.getAttribute('aria-hidden') !== 'false') return;
      // Ignore clicks inside the drawer panel itself
      if (e.target.closest && e.target.closest('.cd__panel')) return;
      // Ignore clicks on anything that opens the cart (handled separately)
      if (e.target.closest && e.target.closest('a[href*="/cart"], .cart-icon-bubble, .cart-link, .cart-count-bubble, [data-action="toggle-cart"]')) return;
      close();
    });

    bindItemButtons();
    hookCartLinks();
    interceptFetch();
    renderProgress(total);
    animateBar(total);
    loadUpsells();

    // Let the JS take over rendering immediately on page load, so per-item
    // savings, post-coupon prices, total savings and the struck subtotal all
    // show right away (not only after the cart changes).
    refreshFromServer();
  }

  function open() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');
    showBackdrop();
    // Re-animate bar each time drawer opens so the fill is always visible
    var t = parseInt(drawer.dataset.cartTotal || '0', 10);
    animateBar(t);
  }
  function close() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
    hideBackdrop();
  }

  // Dedicated dim layer appended straight to <body>. z-index sits just below
  // the drawer panel (.cd) so the panel stays on top while everything else dims.
  var backdrop = null;
  function showBackdrop() {
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.id = 'cd-backdrop';
      backdrop.style.cssText =
        'position:fixed;top:0;left:0;right:0;bottom:0;width:100vw;height:100vh;' +
        'background:rgba(0,0,0,0.45);z-index:2147483000;cursor:pointer;' +
        'opacity:0;transition:opacity 0.3s ease;';
      backdrop.addEventListener('click', close);
      document.body.appendChild(backdrop);
    }
    backdrop.style.display = 'block';
    // Force reflow then fade in
    void backdrop.offsetWidth;
    backdrop.style.opacity = '1';
  }
  function hideBackdrop() {
    if (!backdrop) return;
    backdrop.style.opacity = '0';
    setTimeout(function() { if (backdrop) backdrop.style.display = 'none'; }, 300);
  }

  function hookCartLinks() {
    var sels = [
      'a[href="/cart"]', 'a[href="/cart/"]',
      '.cart-icon-bubble', '.site-header__cart', '.header__icon--cart',
      '.js-cart-toggle', '.cart-link', '#cart-icon-bubble',
      '.header-cart-btn', '[data-action="toggle-cart"]',
      '.cart-count-bubble', 'a[href*="/cart"]'
    ];
    document.querySelectorAll(sels.join(',')).forEach(function(el) {
      if (el.closest('.cd') || el.closest('.cd__footer')) return;
      if (el.getAttribute('href') === '/checkout') return;
      el.addEventListener('click', function(e) {
        e.preventDefault(); e.stopPropagation(); open();
      });
    });
  }

  function hookAddForms() {
    document.querySelectorAll('form[action="/cart/add"]').forEach(function(form) {
      if (form.dataset.cdHooked) return;
      form.dataset.cdHooked = '1';
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var input = form.querySelector('[name="id"]');
        if (!input) return;
        var btn = form.querySelector('[type="submit"], button:not([type="button"])');
        if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
        addToCart(input.value).finally(function() {
          if (btn) { btn.disabled = false; btn.textContent = 'Add to Cart'; }
        });
      });
    });
  }

  function interceptFetch() {
    var origFetch = window.fetch;
    window.fetch = function() {
      var url = arguments[0];
      var urlStr = (typeof url === 'string') ? url : (url && url.url ? url.url : '');
      if (urlStr.indexOf('/cart/add') !== -1) {
        return origFetch.apply(this, arguments).then(function(response) {
          var clone = response.clone();
          clone.json().then(function() {
            setTimeout(function() { refreshFromServer(); open(); }, 300);
          }).catch(function() {});
          return response;
        });
      }
      return origFetch.apply(this, arguments);
    };
  }

  function bindItemButtons() {
    drawer.querySelectorAll('.cd__qty-btn').forEach(function(btn) {
      btn.onclick = function() { updateQty(btn.dataset.key, btn.dataset.action); };
    });
    drawer.querySelectorAll('.cd__item-del').forEach(function(btn) {
      btn.onclick = function() {
        var item = btn.closest('.cd__item');
        if (item) { item.style.opacity = '0'; item.style.transform = 'translateX(20px)'; }
        setTimeout(function() { removeItem(btn.dataset.key); }, 180);
      };
    });
  }

  function updateQty(key, action) {
    var item = drawer.querySelector('.cd__item[data-key="' + key + '"]');
    var qtyEl = item ? item.querySelector('.cd__qty-val') : null;
    var qty = parseInt(qtyEl ? qtyEl.textContent : '1', 10);
    qty = action === 'increase' ? qty + 1 : Math.max(0, qty - 1);
    if (qtyEl) qtyEl.textContent = qty;

    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) { onCartUpdate(cart); })
    .catch(function(err) { console.error('qty fail', err); refreshFromServer(); });
  }

  function removeItem(key) {
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) { onCartUpdate(cart); })
    .catch(function(err) { console.error('remove fail', err); refreshFromServer(); });
  }

  function addToCart(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function() { return refreshFromServer(); })
    .then(function() { open(); })
    .catch(function(err) { console.error('add fail', err); });
  }

  function refreshFromServer() {
    return fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { onCartUpdate(cart); })
      .catch(function(err) { console.error('refresh fail', err); });
  }

  function onCartUpdate(cart) {
    // Make sure we know compare-at prices for every item, then render.
    ensureCompareData(cart.items).then(function() { renderCart(cart); });
  }

  function renderCart(cart) {
    // The value used to qualify discount tiers must be the subtotal BEFORE the
    // automatic order discount — otherwise the discount lowers the total below
    // the threshold and the tier "un-qualifies" itself.
    var qt = (typeof cart.items_subtotal_price === 'number')
      ? cart.items_subtotal_price : cart.total_price;
    var tier = getTier(qt);
    var pct = getDiscount(qt);

    // Keep data attr in sync (used by open() bar animation) — store qualifying total
    if (drawer) drawer.dataset.cartTotal = qt;

    // Count
    var badge = document.getElementById('cd-count');
    if (badge) badge.textContent = cart.item_count;
    document.querySelectorAll('.cart-count-bubble span, .cart-count, [data-cart-count]').forEach(function(el) {
      el.textContent = cart.item_count;
    });

    // Subtotal — show the final (post-discount) total, matching checkout
    var subEl = document.getElementById('cd-subtotal');
    if (subEl) subEl.textContent = money(cart.total_price);

    // Rebuild items from JSON
    var itemsEl = document.getElementById('cd-items');
    var totalCompareSaving = 0;
    var totalCouponSaving = 0;
    var totalMRP = 0;
    if (itemsEl) {
      if (cart.item_count === 0) {
        itemsEl.innerHTML = '<div class="cd__empty"><p>Your cart is empty</p><a href="/collections/all">Start Shopping →</a></div>';
      } else {
        var html = '';
        for (var i = 0; i < cart.items.length; i++) {
          var it = cart.items[i];
          var varTitle = (it.variant_title && it.variant_title !== 'Default Title')
            ? '<span class="cd__item-var">' + esc(it.variant_title) + '</span>' : '';
          var imgSrc = it.image ? it.image.replace(/(\.\w+)(\?|$)/, '_120x120_crop_center$1$2') : '';

          var vid = it.variant_id || it.id;
          var compareUnit = compareCache[vid] || 0;
          var compareLine = compareUnit * it.quantity;       // MRP line total
          var sellingLine = it.final_line_price;             // price before coupon
          var hasCompare = compareLine > sellingLine;

          // Coupon share for this item (only when a tier is achieved)
          var itemCouponSave = (tier >= 0) ? Math.round(sellingLine * pct / 100) : 0;
          var displayPrice = sellingLine - itemCouponSave;   // price AFTER coupon (black)

          // MRP struck through (falls back to selling price if no compare set)
          var mrpLine = hasCompare ? compareLine : sellingLine;
          totalMRP += mrpLine;

          var itemCompareSave = hasCompare ? (compareLine - sellingLine) : 0;
          var itemSave = itemCompareSave + itemCouponSave;
          totalCompareSaving += itemCompareSave;
          totalCouponSaving += itemCouponSave;

          var compareHtml = (CONFIG.showCompare && hasCompare)
            ? '<span class="cd__item-compare">' + money(compareLine) + '</span>' : '';
          var saveHtml = (CONFIG.showItemSaving && itemSave > 0)
            ? '<span class="cd__item-saving">You saved ' + money(itemSave) + '</span>' : '';

          html +=
            '<div class="cd__item" data-key="' + it.key + '">' +
              '<a href="' + it.url + '" class="cd__item-img"><img src="' + imgSrc + '" alt="' + esc(it.title) + '"></a>' +
              '<div class="cd__item-info">' +
                '<a href="' + it.url + '" class="cd__item-name">' + esc(it.product_title) + '</a>' + varTitle +
                '<div class="cd__item-row">' +
                  '<div class="cd__qty">' +
                    '<button class="cd__qty-btn" data-action="decrease" data-key="' + it.key + '">−</button>' +
                    '<span class="cd__qty-val">' + it.quantity + '</span>' +
                    '<button class="cd__qty-btn" data-action="increase" data-key="' + it.key + '">+</button>' +
                  '</div>' +
                  '<span class="cd__item-prices">' +
                    compareHtml +
                    '<span class="cd__item-price">' + money(displayPrice) + '</span>' +
                    saveHtml +
                  '</span>' +
                '</div>' +
              '</div>' +
              '<button class="cd__item-del" data-key="' + it.key + '" aria-label="Remove"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg></button>' +
            '</div>';
        }
        itemsEl.innerHTML = html;
        if (cart.items.length > 0) itemsEl.dataset.firstProductId = cart.items[0].product_id;
      }
      bindItemButtons();
    }

    // Subtotal compare (total MRP struck through, only if it beats the final total)
    var subCompareEl = document.getElementById('cd-subtotal-compare');
    if (subCompareEl) {
      if (CONFIG.showCompare && totalMRP > cart.total_price) {
        subCompareEl.style.display = 'inline';
        subCompareEl.textContent = money(totalMRP);
      } else {
        subCompareEl.style.display = 'none';
      }
    }

    // Total savings = sum of per-item (MRP saving + coupon share)
    var totalSavings = totalCompareSaving + totalCouponSaving;

    var savingsRow = document.getElementById('cd-savings-row');
    var savingsVal = document.getElementById('cd-savings-val');
    if (CONFIG.showTotalSaving && totalSavings > 0) {
      if (savingsRow) savingsRow.style.display = 'flex';
      if (savingsVal) savingsVal.textContent = money(totalSavings);
    } else {
      if (savingsRow) savingsRow.style.display = 'none';
    }

    // Milestone celebration (based on qualifying subtotal, not discounted total)
    var newTier = getTier(qt);
    if (CONFIG.showConfetti && newTier > prevTier && newTier >= 0) celebrate(newTier);
    prevTier = newTier;

    // Progress (animated) — uses qualifying subtotal
    renderProgress(qt);
    animateBar(qt);

    // Upsells
    loadUpsells();
  }

  function getTier(total) {
    var t = -1;
    for (var i = 0; i < TIERS.length; i++) if (total >= TIERS[i].min) t = i;
    return t;
  }
  function getDiscount(total) {
    var d = 0;
    for (var i = 0; i < TIERS.length; i++) if (total >= TIERS[i].min) d = TIERS[i].pct;
    return d;
  }

  function progressPct(total) {
    var maxMin = TIERS[TIERS.length - 1].min;
    return Math.min(100, Math.max(0, (total / maxMin) * 100));
  }

  // Render the progress markup (message + labels + bar at 0 width)
  function renderProgress(total) {
    var wrap = document.getElementById('cd-progress');
    var couponTag = document.getElementById('cd-coupon');
    if (!wrap) return;

    var tier = getTier(total);
    var msg = '';
    if (tier === TIERS.length - 1) {
      msg = '🎉 <strong>' + TIERS[tier].label + '</strong> applied! Best deal unlocked.';
    } else {
      var next = TIERS[tier + 1];
      var rem = next.min - total;
      if (tier === -1) {
        msg = 'Add <strong>' + money(rem) + '</strong> more to unlock <strong>' + next.label + '</strong>';
      } else {
        msg = '✅ ' + TIERS[tier].label + '! Add <strong>' + money(rem) + '</strong> for <strong>' + next.label + '</strong>';
      }
    }

    var labels = '<span>₹0</span>';
    for (var i = 0; i < TIERS.length; i++) {
      var on = total >= TIERS[i].min;
      labels += '<span class="' + (on ? 'cd__prog-label on' : '') + '">' + (on ? '✅' : '🔒') + ' ' + TIERS[i].tag + '</span>';
    }

    var fillCls = tier === TIERS.length - 1 ? ' maxed' : '';
    var pct = progressPct(total);
    var fillColor = (tier === TIERS.length - 1)
      ? 'linear-gradient(90deg,#a855f7,#7c3aed)'
      : 'linear-gradient(90deg,#16a34a,#22c55e)';

    // Inline ALL critical styles directly so the bar renders correctly even
    // if the CSS file is cached/stale. The fill width = real percentage.
    var barStyle = 'height:8px;background:#e5e7eb;border-radius:99px;overflow:hidden;position:relative;width:100%;';
    var fillStyle = 'height:100%;border-radius:99px;background:' + fillColor +
      ';width:' + pct + '%;transition:width 0.6s cubic-bezier(0.32,0.72,0,1);display:block;';

    wrap.innerHTML =
      '<div class="cd__prog-msg">' + msg + '</div>' +
      '<div class="cd__prog-bar" style="' + barStyle + '">' +
        '<div class="cd__prog-fill' + fillCls + '" id="cd-prog-fill" style="' + fillStyle + '"></div>' +
      '</div>' +
      '<div class="cd__prog-labels">' + labels + '</div>';

    // Sync the coupon tag here too (so it works even without animateBar)
    var ct = document.getElementById('cd-coupon');
    if (ct) {
      if (tier >= 0) {
        ct.style.display = 'inline-flex';
        ct.textContent = '🏷️ ' + TIERS[tier].code + ' — ' + TIERS[tier].label;
      } else {
        ct.style.display = 'none';
      }
    }
  }

  // Set the fill to its real width (CSS transition makes it grow smoothly).
  function animateBar(total) {
    var fill = document.getElementById('cd-prog-fill');
    if (!fill) return;
    fill.style.width = progressPct(total) + '%';

    // Coupon tag
    var couponTag = document.getElementById('cd-coupon');
    if (couponTag) {
      var tier = getTier(total);
      if (tier >= 0) {
        couponTag.style.display = 'inline-flex';
        couponTag.textContent = '🏷️ ' + TIERS[tier].code + ' — ' + TIERS[tier].label;
      } else {
        couponTag.style.display = 'none';
      }
    }
  }

  function applyStaticConfig() {
    // Shipping tag (footer)
    var shipTag = document.getElementById('cd-ship-tag');
    if (shipTag) {
      if (CONFIG.showShipTag) {
        shipTag.style.display = '';
        shipTag.innerHTML = CONFIG.shipEmoji + ' ' + CONFIG.shipText +
          ' <small>' + CONFIG.shipSubtext + '</small>';
      } else {
        shipTag.style.display = 'none';
      }
    }
    // Upsell title
    var upTitle = document.querySelector('.cd__upsell-title');
    if (upTitle && CONFIG.upsellTitle) upTitle.textContent = CONFIG.upsellTitle;
  }

  function celebrate(tierIndex) {
    var fall = (window.innerHeight || 800) + 60;

    // Inject keyframes
    var styleEl = document.getElementById('cd-confetti-style');
    if (styleEl) { styleEl.parentNode.removeChild(styleEl); }
    styleEl = document.createElement('style');
    styleEl.id = 'cd-confetti-style';
    styleEl.textContent =
      '@keyframes cdFall{' +
      '0%{transform:translate(0,0) rotate(0deg);opacity:1}' +
      '90%{opacity:1}' +
      '100%{transform:translate(var(--dx,0px),' + fall + 'px) rotate(var(--rot,540deg));opacity:0}}';
    (document.head || document.documentElement).appendChild(styleEl);

    // Attach to the DRAWER element (stable — never wiped by the theme),
    // but render fixed/full-screen so confetti covers the whole viewport.
    var host = drawer || document.body;

    var existing = document.getElementById('cd-celebrate-layer');
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);

    var layer = document.createElement('div');
    layer.id = 'cd-celebrate-layer';
    layer.style.cssText =
      'position:fixed;top:0;left:0;width:100%;height:100%;' +
      'overflow:hidden;pointer-events:none;z-index:2147483647;';

    var colors = ['#f59e0b', '#e8b04b', '#16a34a', '#22c55e', '#3b82f6',
                  '#ec4899', '#a855f7', '#ef4444', '#14b8a6', '#A67C52'];
    for (var i = 0; i < 120; i++) {
      var bit = document.createElement('div');
      var color = colors[i % colors.length];
      var w = 7 + Math.random() * 7;
      var h = 10 + Math.random() * 8;
      bit.style.position = 'absolute';
      bit.style.top = '-24px';
      bit.style.left = (Math.random() * 100) + '%';
      bit.style.width = w + 'px';
      bit.style.height = h + 'px';
      bit.style.background = color;
      bit.style.borderRadius = (Math.random() > 0.7) ? '50%' : '2px';
      bit.style.opacity = '0';
      bit.style.setProperty('--dx', (Math.random() * 200 - 100).toFixed(0) + 'px');
      bit.style.setProperty('--rot', (Math.random() * 720 - 360).toFixed(0) + 'deg');
      bit.style.animation = 'cdFall ' + (2.2 + Math.random() * 1.5).toFixed(2) +
        's cubic-bezier(0.25,0.6,0.45,1) ' + (Math.random() * 0.8).toFixed(2) + 's forwards';
      layer.appendChild(bit);
    }

    host.appendChild(layer);

    // Keep it alive: if anything removes it early, re-attach. Stop after 4.5s.
    var start = Date.now();
    var guard = setInterval(function() {
      if (Date.now() - start > 4500) {
        clearInterval(guard);
        if (layer.parentNode) layer.parentNode.removeChild(layer);
        return;
      }
      if (!layer.parentNode) { host.appendChild(layer); }
    }, 300);
  }

  function loadUpsells() {
    var itemsEl = document.getElementById('cd-items');
    var pid = itemsEl ? itemsEl.dataset.firstProductId : null;
    var section = document.getElementById('cd-upsell');
    var list = document.getElementById('cd-upsell-list');
    if (!CONFIG.showUpsell) { if (section) section.style.display = 'none'; return; }
    if (!pid || !section || !list) { if (section) section.style.display = 'none'; return; }

    fetch('/recommendations/products.json?product_id=' + pid + '&limit=' + (CONFIG.upsellMax || 6) + '&intent=related')
      .then(function(r) { if (!r.ok) throw new Error('rec fail'); return r.json(); })
      .then(function(data) {
        var prods = data.products;
        if (!prods || prods.length === 0) { section.style.display = 'none'; return; }
        var h = '';
        for (var i = 0; i < Math.min(CONFIG.upsellMax || 6, prods.length); i++) {
          var p = prods[i];
          var img = (p.images && p.images.length > 0) ? p.images[0] : '';
          var imgSrc = typeof img === 'string' ? img : (img.src || '');
          if (imgSrc) imgSrc = imgSrc.replace(/(\.\w+)(\?|$)/, '_160x160$1$2');
          var price = (p.variants && p.variants[0]) ? money(p.variants[0].price) : '';
          var vid = (p.variants && p.variants[0]) ? p.variants[0].id : '';
          h +=
            '<div class="cd__up-card">' +
              (imgSrc ? '<img src="' + imgSrc + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
              '<div class="cd__up-card-name">' + esc(p.title) + '</div>' +
              '<span class="cd__up-card-price">' + price + '</span>' +
              '<button class="cd__up-card-btn" data-vid="' + vid + '">+ Add</button>' +
            '</div>';
        }
        list.innerHTML = h;
        section.style.display = '';
        list.querySelectorAll('.cd__up-card-btn').forEach(function(btn) {
          btn.addEventListener('click', function() {
            var vid = btn.dataset.vid;
            if (!vid) return;
            btn.textContent = 'Adding...'; btn.disabled = true;
            addToCart(parseInt(vid, 10)).then(function() {
              btn.textContent = '✓ Added';
              setTimeout(function() { btn.textContent = '+ Add'; btn.disabled = false; }, 1000);
            });
          });
        });
      })
      .catch(function() { section.style.display = 'none'; });
  }

  function money(paise) {
    return 'Rs. ' + (paise / 100).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }
  function esc(str) {
    if (!str) return '';
    return str.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  window.cdAddToCart = addToCart;
  window.cdOpen = open;
  window.cdClose = close;
  // Manual test: open console and run  cdTestConfetti()  to preview the celebration
  window.cdTestConfetti = function(t) { open(); celebrate(typeof t === 'number' ? t : 0); };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

})();